import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import Loadable from 'react-loadable';

const Home = Loadable({
  loader: () => import(/* webpackChunkName: "homepage" */ '../pages'),
  loading: () => null,
  modules: ['homepage']
});

const Mt = Loadable({
  loader: () => import(/* webpackChunkName: "moneytable" */ '../pages/moneytable'),
  loading: () => null,
  modules: ['moneytable']
});

const BlogDetails = Loadable({
  loader: () => import(/* webpackChunkName: "blogDetails" */ '../pages/blogDetails'),
  loading: () => null,
  modules: ['blogDetails']
});

const Blog = Loadable({
  loader: () => import(/* webpackChunkName: "blog" */ '../pages/blog'),
  loading: () => null,
  modules: ['blog']
});

const Contact = Loadable({
  loader: () => import(/* webpackChunkName: "contact" */ '../pages/contact'),
  loading: () => null,
  modules: ['contact']
});

const Thankyou = Loadable({
  loader: () => import(/* webpackChunkName: "hrThankyou" */ '../pages/hrThankyou'),
  loading: () => null,
  modules: ['hrThankyou']
});

const Aboutus = Loadable({
  loader: () => import(/* webpackChunkName: "aboutus" */ '../pages/aboutus'),
  loading: () => null,
  modules: ['aboutus']
});

const Condition = Loadable({
  loader: () => import(/* webpackChunkName: "condition" */ '../pages/condition'),
  loading: () => null,
  modules: ['condition']
});

const Privacy = Loadable({
  loader: () => import(/* webpackChunkName: "privacy" */ '../pages/privacy'),
  loading: () => null,
  modules: ['privacy']
});

const Career = Loadable({
  loader: () => import(/* webpackChunkName: "career" */ '../pages/career'),
  loading: () => null,
  modules: ['career']
});

const Financial = Loadable({
  loader: () => import(/* webpackChunkName: "financial" */ '../pages/financial'),
  loading: () => null,
  modules: ['financial']
});

const ActivityDetails = Loadable({
  loader: () => import(/* webpackChunkName: "activityDetails" */ '../pages/activityDetails'),
  loading: () => null,
  modules: ['activityDetails']
});

const Activity = Loadable({
  loader: () => import(/* webpackChunkName: "activity" */ '../pages/activity'),
  loading: () => null,
  modules: ['activity']
});

const Testimonial = Loadable({
  loader: () => import(/* webpackChunkName: "testimonial" */ '../pages/testimonial'),
  loading: () => null,
  modules: ['testimonial']
});

const Ourteam = Loadable({
  loader: () => import(/* webpackChunkName: "ourteam" */ '../pages/ourteam'),
  loading: () => null,
  modules: ['ourteam']
});

const PromotionDetails = Loadable({
  loader: () => import(/* webpackChunkName: "promotionDetails" */ '../pages/promotionDetails'),
  loading: () => null,
  modules: ['promotionDetails']
});

const Promotion = Loadable({
  loader: () => import(/* webpackChunkName: "promotion" */ '../pages/promotion'),
  loading: () => null,
  modules: ['promotion']
});

const DayCash = Loadable({
  loader: () => import(/* webpackChunkName: "daycash" */ '../pages/daycash'),
  loading: () => null,
  modules: ['daycash']
});

// const RedirectPage = Loadable({
//   loader: () => import(/* webpackChunkName: "RedirectPage" */ '../pages/RedirectPage'),
//   loading: () => null,
//   modules: ['RedirectPage']
// });

const NotFound = Loadable({
  loader: () => import(/* webpackChunkName: "NotFound" */ '../pages/NotFound'),
  loading: () => null,
  modules: ['NotFound']
});

const Routes = () => (
  <Switch>
    <Route exact path='/:lng(en)?' component={Home} />

    <Redirect from='/:lng(en)?/mt' to="/:lng(en)?/moneytable" />

    <Route path='/:lng(en)?/moneytable' component={Mt} />
    <Route path='/:lng(en)?/daycash' component={DayCash} />


    <Route path='/:lng(en)?/contact/thankyou' component={Thankyou} />
    <Route path='/:lng(en)?/contact' component={Contact} />
    <Route path='/:lng(en)?/contact-mt' component={Contact} />
    <Route path='/:lng(en)?/aboutus' component={Aboutus} />
    <Route path='/:lng(en)?/condition' component={Condition} />
    <Route path='/:lng(en)?/privacy' component={Privacy} />
    <Route path='/:lng(en)?/career' component={Career} />
    <Route path='/:lng(en)?/financial' component={Financial} />

    <Route path='/:lng(en)?/blog/view/:slug' component={BlogDetails} />
    <Route path='/:lng(en)?/blog/category/:category/pages/:pages' component={Blog} />
    <Route path='/:lng(en)?/blog/category/:category' component={Blog} />
    <Route path='/:lng(en)?/blog/pages/:pages' component={Blog} />
    <Route path='/:lng(en)?/blog' component={Blog} />

    <Route path='/:lng(en)?/activity/view/:slug' component={ActivityDetails} />
    <Route path='/:lng(en)?/activity/category/:category/pages/:pages' component={Activity} />
    <Route path='/:lng(en)?/activity/category/:category' component={Activity} />
    <Route path='/:lng(en)?/activity/pages/:pages' component={Activity} />
    <Route path='/:lng(en)?/activity' component={Activity} />

    <Route path='/:lng(en)?/promotion/view/:slug' component={PromotionDetails} />
    <Route path='/:lng(en)?/promotion/category/:category/pages/:pages' component={Promotion} />
    <Route path='/:lng(en)?/promotion/category/:category' component={Promotion} />
    <Route path='/:lng(en)?/promotion/pages/:pages' component={Promotion} />
    <Route path='/:lng(en)?/promotion' component={Promotion} />

    <Route path='/:lng(en)?/testimonial/category/:category/pages/:pages' component={Testimonial} />
    <Route path='/:lng(en)?/testimonial/category/:category' component={Testimonial} />
    <Route path='/:lng(en)?/testimonial/pages/:pages' component={Testimonial} />
    <Route path='/:lng(en)?/testimonial' component={Testimonial} />
    <Route path='/:lng(en)?/ourteam' component={Ourteam} />

    {/* for 404 page - lasted only */}
    <Route path="*" component={NotFound} />
  </Switch>
)

export default Routes;


// WEBPACK FOOTER //
// ./src/routes/index.jsx